import React from 'react';
import {
  Container,
  List,
  ListItem,
  ListItemText,
  Grid,
  makeStyles,
  Typography,
  Box,
  
} from '@material-ui/core';
import { useAlertContext } from 'src/context/AlertContext';
import {FishesList} from './fishes-list';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  navbar: {
    height: '100%',
    background: theme.palette.background.default,
  },
  container: {
    height: '100%',
  },
  grid: {
    height: 'calc(100vh - 48px)',
  },
}));

export const HarvesterLandScreen = () => {
  const classes = useStyles();
  const { useAlert } = useAlertContext();

  return (
    <Page title="Harvestland">
      <Grid container className={classes.grid}>
        <Grid item xs={12} md={2} >
          <List
            className={classes.navbar}
            subheader={
              <Box p={1}>
                <Typography variant="h4" gutterBottom>
                  Harvest Land
                </Typography>
              </Box>
            }
          >
            <ListItem button selected>
              <ListItemText primary="Pastor's Friend" />
            </ListItem>

            <ListItem
              button
              selected={false}
              onClick={() =>
                useAlert(
                  'Harvestland doesn`t have any fishes from Facebook groups yet, it is coming soon',
                  'warning'
                )
              }
            >
              <ListItemText primary="Facebook groups" />
            </ListItem>

            <ListItem
              button
              selected={false}
              onClick={() =>
                useAlert(
                  'Harvestland doesn`t have any fishes from Instagram pages yet, it is coming soon',
                  'warning'
                )
              }
            >
              <ListItemText primary="Instagram pages" />
              
            </ListItem>
          </List>
        </Grid>
        <Grid item md={10}>
          <Container className={classes.container}>
            <Box p={2}>
              <Typography variant="h4" gutterBottom>
                {'Pastor\'s'} friend fishing list
              </Typography>
            </Box>
            <FishesList/>
          </Container>
        </Grid>
      </Grid>
    </Page>
  );
};
